import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, M_ElementDrawer, NavigateContext } from 'src/M_Components'
import { AirlineStopsOutlined, Anchor, Refresh } from '@mui/icons-material'
import { _ } from 'ajv'


export const TransportCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null) 
    const [showTransportMeans, setShowTransportMeans] = useState(false)
    const [newTransportMeansData, setNewTransportMeansData] = useState({})

    const transportService = new BufferService('Transport', 'secondary')
    const transportMeansService = new BufferService('TransportMeans', 'secondary')

    const tradeService = new BufferService('Trade', 'secondary')
    const voyageService = new BufferService('Voyage')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    // ============================================================================
    // ==================== Transport Means CREATION ===============================
    const addTransportMeansFields = [
        { display: t('Transport')+' '+t('Means')+' '+t('Comments'), required: true, code: 'transportMeansComments', type: 'textArea', fullWidth: true },
    ]

    const saveNewTransportMeans = () => {
        // Validations
        if (!newTransportMeansData.transportMeansComments) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }
        
        ctx.setIsLoad(true)
        
        const transportMeansData = {
            Comment: newTransportMeansData.transportMeansComments,
        }

        transportMeansService.post(transportMeansData).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', t('Failed to create')+' '+t('Transport')+' '+t('Means'))
                return
            }
            
            ctx.toastMessages('success', '', t('Transport')+' '+t('Means')+' '+t('savedSuccessfully'))
            setShowTransportMeans(false)
            setNewTransportMeansData({})

        }).catch(error => {
            ctx.setIsLoad(false)
            ctx.toastMessages('error', '', t('Error saving')+' '+t('Transport')+' '+t('Means'))
        })
    }
    // ============================================================================

    // Fields
    const TransportFields = [
        { display: t('Mov. Key')+' '+t('Type'), required: true, code: 'movTypeCode', type: 'foreignKey', entity: 'MovementType', api:'secondary' , filterField: 'Code', labelFields: ['Code'], fields: [{ key: 'Name', value: 'movTypeName' }, { key: 'Code', value: 'movTypeCode' }, { key: 'Id', value: 'movTypeCodeId' }], },
        { display: t('Trade')+' '+t('Line'), required: true,  code: 'tradeLine', type: 'foreignKey', entity: 'Trade', filterField: 'TradeLineName', labelFields: ['TradeLineName'], fields: [{ key: 'TradeLineName', value: 'tradeLine' },{ key: 'Id', value: 'tradeLineId' }], },
        { display: t('Voyage'), required: true, code: 'voyage', type: 'foreignKey', entity: 'Voyage', filterField: 'VoyageNumber', labelFields: ['VoyageNumber'], fields: [{ key: 'VoyageNumber', value: 'voyage' }, { key: 'VoyageId', value: 'voyageId' }], },

        { display: t('Date'), required: true, code: 'transportDate', type: 'date' },
        { display: t('Exchange'), required: true, code: 'exchange', type: 'date' },

        { display: t('Accounting'), required: true, type: 'text', code: 'accounting' },
        { display: t('State'), required: true, type: 'text', code: 'state'},
        { type: 'separator' }, { display: t('Transport')+' '+t('Comments'), code: 'transportComments', required: true, type: 'textArea', fullWidth: true }
    ]


    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingTransport = JSON.parse(sessionStorage.getItem('editingTransport'))
            const operationType = sessionStorage.getItem('operationType')
            
            if (editingTransport && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyTransport(editingTransport.Id, operationType === 'Copy')
                
                sessionStorage.removeItem('editingTransport')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {

            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)

            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const refreshTransport = () => {
        ctx.setIsLoad(true)
        
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        
        // Initial values
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null) 
        
        get()
        
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')    
    }

    const checkTransportExists = async (movementTypeKey, tradeId, excludeId = null) => {
        if (!movementTypeKey || !tradeId) return false
        
        try {
            const response = await transportService.filter(`?filter=MovementTypeKey eq '${movementTypeKey}'`)
            
            if (response.name === 'AxiosError' || !response?.Items) {
                return false
            }
            
            const matchingItems = response.Items.filter(item => {
                const itemTradeId = item.TradeId?.toString().toLowerCase()
                const searchTradeId = tradeId.toString().toLowerCase()
                
                return itemTradeId === searchTradeId
            })
            
            if (excludeId) {
                const otherItems = matchingItems.filter(item => item.Id !== excludeId)
                return otherItems.length > 0;
            }
            
            return matchingItems.length > 0;

        } catch (error) {
            console.error('Error checking transport:', error)
            return false
        }
    }

    const onSave = async () => {

        // Validations
        if (!data.movTypeCode || !data.transportDate || !data.accounting || !data.state || !data.tradeLine || !data.voyageId || !data.exchange || !data.transportComments ) {
            ctx.toastMessages('error', '', 'Missing required fields')
            return
        }

        let shouldCheckDuplicate = false
        if (!isEditMode) {
            shouldCheckDuplicate = true
        } else {
            const movTypeChanged = data.movTypeCode !== data._originalMovTypeCode
            const tradeChanged = data.tradeLineId !== data._originalTradeId
            
            if (movTypeChanged || tradeChanged) {
                shouldCheckDuplicate = true
            }
        }
        
        if (shouldCheckDuplicate) {
            ctx.setIsLoad(true)
            const exists = await checkTransportExists(data.movTypeCode, data.tradeLineId, editingId)
            ctx.setIsLoad(false)
            
            if (exists) {
                ctx.toastMessages('error', '', `${t('Transport')} ${data.movTypeCode} ${data.tradeLineId} ${t('alreadyExists')}`)
                return
            }
        }
        
        const transportData = {
            MovementTypeKey: data.movTypeCode,
            TradeLine: data.tradeLine,
            TradeId: data.tradeLineId? data.tradeLineId : null,
            VoyageId: data.voyageId? data.voyageId : null,
            Date: data.transportDate,
            Exchange: data.exchange,
            Accounting: data.accounting,
            State: data.state,
            Comments: data.transportComments,
        }
        
        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId 
            ? transportService.update(editingId, transportData)
            : transportService.post(transportData)
        
        savePromise.then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }
            
            // Success
            const successMessage = isEditMode ?  t('Transport') +  t('updatedSucessfully') : t('Transport') +  t('savedSucessfully')
            ctx.toastMessages('success', '', successMessage)
            
            ctx2.closeTab(JSON.parse(id))            
        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyTransport = (transportId, isCopy = false) => {
        ctx.setIsLoad(true)
        
        transportService.getId(transportId).then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', t('Failed to load')+' '+t('Transport'))
                return
            }
            
            
            // Mapper
            const transportData = {
                movTypeCode: isCopy ? '' : (response.MovementTypeKey?.toString() || ''),
                tradeLine: response.TradeLine,
                tradeLineId: response.TradeId?.toString() || '',
                voyageId: response.VoyageId?.toString() || '',
                transportDate: response.Date?.split('T')[0],
                exchange: response.Exchange?.split('T')[0],
                accounting: response.Accounting,
                state: response.State,
                transportComments: response.Comments,
                
                _originalMovTypeCode: response.MovementTypeKey?.toString() || '',
                _originalTradeId: response.TradeId?.toString() || '',
                _isCopy: isCopy,
                _originalId: isCopy ? transportId : null
            }

            if (isCopy) {
                delete transportData.Id
                delete transportData.ExternalId
                delete transportData.CreatedAt
                delete transportData.UpdatedAt

                setIsEditMode(false)  
                setEditingId(null)        
                setOperation('Copy')    
            } else {
                setIsEditMode(true)         
                setEditingId(transportId) 
                setOperation('Edit')      
            }
            setData(transportData)
            
            // Fetch Trade
            tradeService.filter(`/getByTradeId/${response.TradeId}`).then(tradeRes => {
                if (tradeRes.name !== 'AxiosError') {
                    changes('tradeLine', tradeRes.TradeLineName, setData)
                }
            })
            // Fetch Voyage
            voyageService.filter(`/getByVoyageId/${response.VoyageId}`).then(voyageRes => {
                if (voyageRes.name !== 'AxiosError') {
                    changes('voyage', voyageRes.VoyageNumber, setData)
                    changes('voyageId', voyageRes.VoyageId, setData)
                }
            })
            
        }).catch(error => {
            ctx.setIsLoad(false)
            console.error('Error loading transport:', error)
            ctx.toastMessages('error', '', 'Failed to load transport data')
        })
    }
    
    const handleError = (error) => {
        let errorMessage = t('Failed to create')+' '+t('Transport')
        if (Array.isArray(data)) {
            errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (data?.errors) {
            errorMessage = Object.entries(data.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (data?.message) {
            errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
        } else if (data?.detail) {
            errorMessage = data.detail
        } else if (data?.title) {
            errorMessage = data.title
        } else if (error.message) {
            errorMessage = error.message
        }

        ctx.toastMessages('error', '', errorMessage)
    }


    return (
        <div >
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshTransport()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><AirlineStopsOutlined style={{ marginRight: '10px', scale: '1.3' }} /> {t('Transport')+' '+t('Details')}</div>}
                        headerElement={
                            <M_Button
                                bold
                                normal
                                hoverEffect
                                tooltip={t('Add')+' '+t('New')+' '+t('Transport')+' '+t('Means')}
                                label={matches15 ? t('Add')+' '+t('Transport')+' '+t('Means') : ""}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                icon={<img src='/icons/svgsDaNet/plus-square.svg' alt={t("Add")} style={{ filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7477%) hue-rotate(324deg) brightness(94%) contrast(109%)' }} className='iconCreateBooking' />}
                                onClick={() => setShowTransportMeans(true)}
                            />
                        }
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches10 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {TransportFields.map((field, index) => {
                                    if (field.type === 'separator') {
                                        //New line
                                        return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />;
                                    }
                
                                    if (field.fullWidth) {
                                        return (
                                            <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                                {fields(field, index, data, setData, false, null, '100%')}
                                            </div>
                                        );
                                    }
                                    return fields(field, index, data, setData, null, null)
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div >

            {/* Transport Means Creation Drawer */}
            <M_ElementDrawer
                open={showTransportMeans}
                setOpen={setShowTransportMeans}
                onClose={() => {
                    setShowTransportMeans(false)
                    setNewTransportMeansData({})
                }}
                element={
                    <div style={{ margin: '0px 5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px 0px' }}>
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <h2 style={{ color: ctx.secondaryColor, display: 'flex', alignItems: 'center', marginTop: '0px' }}><Anchor style={{ marginRight: '5px', fontSize: '30px' }} />
                                    {t('New')+' '+t('Transport')+' '+t('Means')+' '+t('Details')}
                                </h2>
                            </span>
                            <div style={{ border: `1px solid ${ctx.primaryColor}`, width: '90%' }}></div>
                        </div>
                        
                        {/*Transport Fields */}
                        <div style={{display: 'grid', gridTemplateColumns: 'auto auto auto', margin: '20px', gap: '20px', alignItems: 'start' }}>          
                            {addTransportMeansFields.map((field, index) => {
                                if (field.fullWidth) {
                                    return (
                                        <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                            {fields(field, index, newTransportMeansData, setNewTransportMeansData, false, null, '100%')}
                                        </div>
                                    );
                                }
                                return fields(field, index, newTransportMeansData, setNewTransportMeansData, null, null)
                            })}
                        </div>
                        <div style={{ margin: '30px 0' }}></div>
                        
                        {/* Buttons Save & Cancel */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginRight: '20px', marginLeft: '20px' }}>                            
                            <M_Button
                                hoverEffect
                                width={20}
                                label={t("Save")}
                                onClick={() => saveNewTransportMeans()}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                            />
                            <M_Button
                                hoverEffect
                                width={15}
                                label={t("Cancel")}
                                onClick={() => {
                                    setShowTransportMeans(false)
                                    setNewTransportMeansData({})
                                }}
                                backgroundColor={'var(--color-red)'}
                                labelColor={'var(--color-white)'}
                            />

                        </div>
                    </div>
                }
            />
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => { ctx2.closeTab(JSON.parse(id)); setLeavingPage(false) }} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div >
    )
}
